module.exports = __webpack_public_path__ + "img/coming-soon.5a2d4ab8.png";